import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import fleetListServices from '@src/services/fleetList/fleetList.services';

export const getFleetCodes = createAsyncThunk(
  'getFleetCodes',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      const { pageNumber = 1, pageSize = 10, StartDate, EndDate, isUsed, externalFleetId } = body;
      const data = {
        Page: pageNumber,
        PageSize: pageSize,
        CustomerId: customerId,
        StartDate,
        EndDate,
        IsUsed: isUsed,
        externalFleetId,
      };
      const res = await fleetListServices.getFleetCodes(data);
      return res;
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const fleetCodeExcelUpload = createAsyncThunk(
  'fleetCodeExcelUpload',
  async (body, { getState, dispatch, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;
      if (!customerId) {
        return rejectWithValue({
          message: 'Lütfen anasayfaya giderek müşteri tipi seçiniz.',
        });
      }
      const data = new FormData();
      data.append('FormFile', body?.FormFile, body?.FormFile?.fileName);
      data.append('CustomerId', customerId);
      data.append('ExcelUploadCheck.FirstRowHeaderColumn', body?.FirstRowHeaderColumn);
      data.append('ExcelUploadCheck.UseDefaultTemplate', false);
      data.append('ExcelUploadCheck.FleetCodeColumn', body?.FleetCodeColumn);

      return await fleetListServices.fleetCodeExcelUpload(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

const initialState = {
  fleetsList: [],
  uploadFleetsList: [],
  pagedProperty: {
    pageSize: 0,
    totalItems: 0,
    currentPage: 1,
  },
  loading: {
    fleetsList: false,
    uploadFleetsList: false,
  },
};

export const fleetListSlice = createSlice({
  name: 'fleetList',
  initialState,
  reducers: {
    resetCurrentLoadVehicleManagement: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFleetCodes.pending, (state) => {
        state.loading.fleetsList = true;
      })
      .addCase(getFleetCodes.fulfilled, (state, action) => {
        state.loading.fleetsList = false;
        state.fleetsList = action?.payload?.data?.items || [];
        state.pagedProperty.pageSize = action?.payload?.data?.pagedProperty?.pageSize || 0;
        state.pagedProperty.totalItems = action?.payload?.data?.pagedProperty?.totalItems || 0;
        state.pagedProperty.currentPage = action?.payload?.data?.pagedProperty?.currentPage || 1;
      })
      .addCase(getFleetCodes.rejected, (state, action) => {
        state.fleetsList = [];
        state.loading.fleetsList = false;
        state.pagedProperty = {
          pageSize: 0,
          totalItems: 0,
          currentPage: 1,
        };
      })
      .addCase(fleetCodeExcelUpload.pending, (state) => {
        state.loading.uploadFleetsList = true;
      })
      .addCase(fleetCodeExcelUpload.fulfilled, (state, action) => {
        state.loading.uploadFleetsList = false;
        state.uploadFleetsList = action?.payload?.data?.validationMessages || [];
      })
      .addCase(fleetCodeExcelUpload.rejected, (state, action) => {
        state.uploadFleetsList = [];
        state.loading.uploadFleetsList = false;
      });
  },
});
